/**
 * Hamburger toggle for the navigation.
 */

const navigation = document.getElementById('site-navigation');
const toggleButton = document.getElementById('site-navigation-button');

const navigationActiveClassName = 'navigation--active';
const toggleButtonActiveClassName = 'hamburger--active';

const showNavigation = () => {
    navigation.classList.add(navigationActiveClassName);
    toggleButton.classList.add(toggleButtonActiveClassName);
    toggleButton.setAttribute('aria-expanded', 'true');
};

const hideNavigation = () => {
    navigation.classList.remove(navigationActiveClassName);
    toggleButton.classList.remove(toggleButtonActiveClassName);
    toggleButton.setAttribute('aria-expanded', 'false');
    document.querySelector('main#content').classList.remove('mega-menu-open');
};

if (navigation && toggleButton) {
    toggleButton.addEventListener('click', e => {
        const isActive = toggleButton.getAttribute('aria-expanded') === 'true';
        isActive ? hideNavigation() : showNavigation();
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            hideNavigation();
        }
    });
}

/**
 * Opening and closing for menu flyouts.
 */

const megaParents = document.querySelectorAll('.mega-parents__item');
const content = document.querySelector('main#content');

const openMegaMenu = parent => {
    const node = parent.querySelector('.mega-parents__node');
    const menu = document.getElementById(node.getAttribute('aria-controls'));
    menu.hidden = false;
    node.setAttribute('aria-expanded', 'true');
    content.classList.add('mega-menu-open');
};

const closeMegaMenu = parent => {
    const node = parent.querySelector('.mega-parents__node');
    const menu = document.getElementById(node.getAttribute('aria-controls'));
    menu.hidden = true;
    node.setAttribute('aria-expanded', 'false');
    content.classList.remove('mega-menu-open');
};

const closeAllMegaMenus = () => {
    megaParents.forEach(parent => closeMegaMenu(parent));
};

const toggleMegaMenu = parent => {
    const node = parent.querySelector('.mega-parents__node');
    const isActive = node.getAttribute('aria-expanded') === 'true';

    // Allow only one open flyout in the desktop navigation
    const isMobileLayout = Boolean(toggleButton.offsetParent);
    if (!isMobileLayout) {
        closeAllMegaMenus();
    }

    if (isActive) {
        closeMegaMenu(parent);
    } else {
        openMegaMenu(parent);
    }
};

if (megaParents.length) {
    megaParents.forEach(parent => {
        const node = parent.querySelector('.mega-parents__node');

        node.addEventListener('click', e => {
            e.preventDefault();
            toggleMegaMenu(parent);
        });

        node.addEventListener('keydown', e => {
            if (!['Enter', ' '].includes(e.key)) return;
            e.preventDefault();
            toggleMegaMenu(parent);
        });
    });

    navigation.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        closeAllMegaMenus();
    });

    document.addEventListener('click', e => {
        if (!navigation || navigation.contains(e.target)) return;
        closeAllMegaMenus();
    });
}
